import React from 'react';
import { Link } from 'react-router-dom';
import './DocumentCard.css';

const DocumentCard = ({ document: doc, onDownload }) => {
  const handleDownloadClick = () => {
    if (onDownload) {
      onDownload(doc.id);
    }
  };

  const getSubjectColor = (subject) => {
    const colors = {
      'Mathematics': '#3B82F6',
      'English': '#10B981',
      'Kiswahili': '#F59E0B',
      'Creative Arts & Social Studies': '#EF4444',
      'Integrated Science': '#8B5CF6',
      'Default': '#6B7280'
    };
    return colors[subject] || colors.Default;
  };

  return (
    <div className="document-card">
      <div className="document-header">
        <div 
          className="document-subject-badge"
          style={{ backgroundColor: getSubjectColor(doc.subject) }}
        >
          {doc.subject.charAt(0)}
        </div>
        <div className="document-meta">
          <span className="document-year">{doc.year}</span>
          <span className="document-type">{doc.type}</span>
        </div>
      </div>
      
      <div className="document-content">
        <h3 className="document-title">{doc.title}</h3>
        <p className="document-subject">{doc.subject}</p>
      </div>
      
      <div className="document-footer">
        <a 
          href={`/documents/${encodeURIComponent(doc.filename)}`}
          download={doc.filename}
          className="download-btn"
          onClick={handleDownloadClick}
          aria-label={`Download ${doc.title}`}
          data-action="download"
          data-text="Download"
        >
          <span className="download-icon">⬇️</span>
          <span className="btn-text">Download</span>
        </a>
        
        <Link 
          to={`/pdf-viewer/${encodeURIComponent(doc.filename)}`}
          className="preview-btn"
          aria-label={`Preview ${doc.title}`}
          data-action="preview"
          data-text="Preview"
        >
          <span className="preview-icon">👁️</span>
          <span className="btn-text">Preview</span>
        </Link>
      </div>
    </div>
  );
};

export default DocumentCard;